import { Button, Dropdown, Input, Select, Tabs } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import MoreIcon from '../../images/more-horizontal.png';
import EditIcon from '../../images/edit.svg';
import LoginIcon from '../../images/login.svg';
import DeleteIcon from '../../images/delete.svg';
import CloseIcon from '../../images/close.svg';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import countryCode from '../../config/countryCode.json';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import axios from '../../helpers/axios';
const accessToken = localStorage.getItem('agentModuleToken');

const UserAccounts = () => {
  const location = useLocation();
  const pagePermission = location.state;
  //console.log('location', pagePermission);

  const methods = useForm({
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmpassword: '',
      phoneNumber: '',
      countryCode: '+65',
      role: '',
    },
  });
  const {
    setValue,
    formState: { errors },
  } = methods;
  const [userModal, setUserModal] = useState({ open: false, type: 'create' });
  const [userAccounts, setUserAccounts] = useState([]);
  const [RoleList, setRoleList] = useState([]);
  const [userCounts, setUserCounts] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [activeTab, setActiveTab] = useState(
    userCounts?.length > 0 ? userCounts[0]?.value : '1'
  );

  const GetAllRoles = async () => {
    const resp = await axios.post('/admin/user-role/list', { status: '' });
    if (resp?.status < 400) {
      setRoleList(resp?.data.data);
    }
  };
  const GetUserAccounts = async () => {
    const resp = await axios.post(
      '/admin/user/list/10/1',
      { status: activeTab },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (resp?.status < 400) {
      setUserAccounts(resp?.data?.data);
      setUserCounts(resp?.data?.counts);
    }
  };

  const GetRoleName = (id) => {
    const temp = RoleList?.filter((it) => it?.id == id);
    return temp?.length > 0 ? temp[0]?.role_name : '';
  };

  const GetUserInfo = async (id) => {
    const resp = await axios.get(`/admin/user/info/${id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (resp?.status < 400) {
      let userInfo = resp.data?.data;
      setValue('firstName', userInfo?.firstName);
      setValue('lastName', userInfo?.lastName);
      setValue('email', userInfo?.email);
      setValue('countryCode', userInfo?.countryCode);
      setValue('phoneNumber', userInfo?.phoneNumber);
      setValue('role', userInfo?.role);
      setUserInfo(userInfo);
      setUserModal({ open: true, type: 'edit' });
    }
  };

  const UpdateUserStatus = async (item, statusValue, id) => {
    const resp = await axios.put(
      `/admin/user/status/update/${id}/${statusValue}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (resp?.data?.resp_code < 400) {
      toast.success(resp?.data?.message);
      GetUserAccounts();
    }
  };
  const HandleUserDelete = async (id) => {
    const resp = await axios.delete(`/admin/user/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    if (resp?.status < 400) {
      toast.error(resp?.data?.message);
      GetUserAccounts();
    }
  };

  useEffect(() => {
    GetUserAccounts();
  }, [activeTab]);

  useEffect(() => {
    GetAllRoles();
  }, []);

  return (
    <div className='min-h-screen bg-[#F5F5F5]'>
      {userModal?.open && (
        <CreateUserAccModal
          methods={methods}
          setUserModal={setUserModal}
          RoleList={RoleList}
          GetUserAccounts={GetUserAccounts}
          userModal={userModal}
          userInfo={userInfo}
        />
      )}
      <div className='pt-[20px] px-[26px] bg-white'>
        <div className='flex items-center gap-[15px] justify-between'>
          <h1 className='text-[20px] font-[700]'>User Accounts</h1>
          {pagePermission?.create_permission == 1 && (
            <Button
              type='primary'
              className='newAccBtn bg-[#055FFB] rounded-[4px] p-[8px_20px] h-[unset] flex items-center gap-[8px] font-[600]'
              onClick={() => setUserModal({ open: true, type: 'create' })}
            >
              <span className='text-[23px] font-[400] leading-[5px] relative bottom-[2px]'>
                +
              </span>
              <span className='txt_cont'>Create New Account</span>
            </Button>
          )}
        </div>
      </div>
      <div className='px-[26px] bg-white border-b border-[#f0f0f0]'>
        <Tabs
          className='userAccTab'
          defaultActiveKey={activeTab}
          items={[
            {
              key: userCounts[0]?.value,
              label: (
                <div>
                  {userCounts[0]?.label}{' '}
                  <span className='ml-[7px] badge rounded-[20px] leading-[0] font-[600] text-[11px] bg-[#0660FC] text-white h-[20px] w-[30px] inline-flex items-center justify-center'>
                    {userCounts[0]?.count}
                  </span>
                </div>
              ),
            },
            {
              key: userCounts[1]?.value,
              label: (
                <div>
                  {userCounts[1]?.label}{' '}
                  <span className='ml-[7px] badge rounded-[20px] leading-[0] font-[600] text-[11px] bg-[#0660FC] text-white h-[20px] w-[30px] inline-flex items-center justify-center'>
                    {userCounts[1]?.count}
                  </span>
                </div>
              ),
            },
          ]}
          onChange={(k) => setActiveTab(k)}
        />
      </div>
      {activeTab == '1' ? (
        <ActiveAccounts
          userAccounts={userAccounts}
          GetRoleName={GetRoleName}
          activeTab={activeTab}
          RoleList={RoleList}
          UpdateUserStatus={UpdateUserStatus}
          HandleUserDelete={HandleUserDelete}
          GetUserInfo={GetUserInfo}
          pagePermission={pagePermission}
        />
      ) : (
        <DeActiveAccounts
          userAccounts={userAccounts}
          GetRoleName={GetRoleName}
          activeTab={activeTab}
          RoleList={RoleList}
          UpdateUserStatus={UpdateUserStatus}
          HandleUserDelete={HandleUserDelete}
          GetUserInfo={GetUserInfo}
          pagePermission={pagePermission}
        />
      )}
    </div>
  );
};

const CreateUserAccModal = (props) => {
  const {
    setUserModal,
    RoleList,
    GetUserAccounts,
    methods,
    userModal,
    userInfo,
  } = props;
  const {
    control,
    watch,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = methods;
  const password = watch('password');
  const [resPassword, setresPassword] = useState(false);
  const ResetFunction = () => {
    reset();
    setUserModal({ open: false, type: 'create' });

    setresPassword(false);
    GetUserAccounts();
  };
  const handleFormSubmit = async (data) => {
    if (userModal?.type === 'edit') {
      let finalObj = !resPassword
        ? { ...delete data.password, ...delete data.confirmpassword }
        : { ...data };
      const resp = await axios.put(`/admin/user/update/${userInfo?.id}`, data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (resp?.data?.resp_code < 400) {
        toast.success(resp?.data?.message);
        ResetFunction();
      }
    } else {
      //console.log('FINAL SUBMIT', data);

      const resp = await axios.post('/admin/user/create', data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (resp?.status < 400) {
        toast.success(resp.data.message);
        ResetFunction();
      }
    }
  };

  return (
    <div className='bg-black bg-opacity-50 fixed z-[999] w-[100%] h-full left-0 top-0 overflow-x-hidden'>
      <div className='w-full max-w-[45rem] bg-white absolute rounded-t-lg md:rounded-none bottom-0 h-[100%] md:h-[100%] right-0 max-h-screen overflow-y-scroll'>
        <div className='flex px-4 py-2 pt-4 md:px-8 md:py-4 justify-between items-center z-9 w-[100%]'>
          <h3 className='text-[20px] text-center flex-[1] font-bold tracking-[-.15px] capitalize'>
            {userModal?.type === 'edit'
              ? 'Update User Account'
              : 'Create New User Account'}
          </h3>
          <div
            className='bg-gray-100 px-2 py-2 rounded-md hover:bg-gray-200 transition-all cursor-pointer'
            onClick={() => {
              setUserModal({ open: false, type: 'create' });
              reset();
            }}
          >
            <img src={CloseIcon} className='w-5 h-5' />
          </div>
        </div>
        <FormProvider {...methods}>
          <div className='p-[32px_36px]'>
            <form
              className='profile_form w-[600px] max-w-full'
              onSubmit={handleSubmit(handleFormSubmit)}
            >
              <div className='flex gap-[0_20px] flex-wrap items-center mt-[30px]'>
                <div className='mb-[20px] flex-[1_1_200px]'>
                  <label className='text-[#495159] text-[13px] font-[600] mb-[8px] block'>
                    First Name
                  </label>
                  <Controller
                    control={control}
                    name='firstName'
                    rules={{
                      required: true,
                    }}
                    render={({ field, fieldState }) => {
                      return (
                        <Input
                          {...field}
                          status={fieldState.error ? 'error' : null}
                          placeholder='Enter First Name'
                          className='h-[40px] border-[#C3D2E2]'
                        />
                      );
                    }}
                  />
                </div>
                <div className='mb-[20px] flex-[1_1_200px]'>
                  <label className='text-[#495159] text-[13px] font-[600] mb-[8px] block'>
                    Last Name
                  </label>
                  <Controller
                    control={control}
                    name='lastName'
                    render={({ field, fieldState }) => {
                      return (
                        <Input
                          {...field}
                          status={fieldState.error ? 'error' : null}
                          placeholder='Enter Last Name'
                          className='h-[40px] border-[#C3D2E2]'
                        />
                      );
                    }}
                  />
                </div>
                <div className='mb-[20px] flex-[1_1_200px]'>
                  <label className='text-[#495159] text-[13px] font-[600] mb-[8px] block'>
                    Email
                  </label>
                  <Controller
                    control={control}
                    name='email'
                    rules={{
                      required: true,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: '*Invalid Email',
                      },
                    }}
                    render={({ field, fieldState }) => {
                      return (
                        <Input
                          {...field}
                          status={fieldState.error ? 'error' : null}
                          placeholder='Enter Email address'
                          className='h-[40px] border-[#C3D2E2]'
                        />
                      );
                    }}
                  />
                </div>
              </div>

              <div className='flex gap-[0_20px] flex-wrap items-center'>
                {userModal?.type === 'edit' && !resPassword ? (
                  <div className='mb-[20px] flex-[1_1_200px]'>
                    <label className='flex justify-between items-center mb-[4px] text-[13px] text-[#798188]'>
                      Password
                      {!resPassword && (
                        <span
                          className='text-blue-600 font-medium cursor-pointer'
                          onClick={() => setresPassword(true)}
                        >
                          Set Password
                        </span>
                      )}
                    </label>
                    <Controller
                      control={control}
                      name='password'
                      // rules={{
                      //     required: true,
                      //     minLength: {
                      //         value: 8,
                      //         message: "Password must have atleast 8 characters",
                      //     },
                      // }}
                      render={({ field, fieldState }) => {
                        return (
                          <Input
                            {...field}
                            disabled
                            type='password'
                            value={'12345678'}
                            status={fieldState.error ? 'error' : null}
                            placeholder='Enter Password'
                            className='h-[40px] border-[#C3D2E2]'
                            iconRender={(visible) =>
                              visible ? (
                                <img
                                  src='/images/pwd_hid.svg'
                                  className='cursor-pointer'
                                />
                              ) : (
                                <img
                                  src='/images/pwd_vis.svg'
                                  className='cursor-pointer'
                                />
                              )
                            }
                          />
                        );
                      }}
                    />
                    {errors.password && (
                      <p className='text-[13px] text-[#ff4d4f]'>
                        {errors.password.message}
                      </p>
                    )}
                  </div>
                ) : (
                  <>
                    <div className='mb-[20px] flex-[1_1_200px]'>
                      <label className='text-[#495159] text-[13px] font-[600] mb-[8px] block'>
                        Password
                      </label>
                      <Controller
                        control={control}
                        name='password'
                        rules={{
                          required: true,
                          minLength: {
                            value: 8,
                            message: 'Password must have atleast 8 characters',
                          },
                        }}
                        render={({ field, fieldState }) => {
                          return (
                            <Input
                              {...field}
                              status={fieldState.error ? 'error' : null}
                              placeholder='Enter Password'
                              className='h-[40px] border-[#C3D2E2]'
                              iconRender={(visible) =>
                                visible ? (
                                  <img
                                    src='/images/pwd_hid.svg'
                                    className='cursor-pointer'
                                  />
                                ) : (
                                  <img
                                    src='/images/pwd_vis.svg'
                                    className='cursor-pointer'
                                  />
                                )
                              }
                            />
                          );
                        }}
                      />
                      {errors.password && (
                        <p className='text-[13px] text-[#ff4d4f]'>
                          {errors.password.message}
                        </p>
                      )}
                    </div>
                    <div className='mb-[20px] flex-[1_1_200px]'>
                      <label className='text-[#495159] text-[13px] font-[600] mb-[8px] block'>
                        Confirm Password
                      </label>
                      <Controller
                        control={control}
                        name='confirmpassword'
                        rules={{
                          required: true,
                          validate: (value) =>
                            value === password || 'Passwords do not match',
                        }}
                        render={({ field, fieldState }) => {
                          return (
                            <Input
                              {...field}
                              status={fieldState?.error ? 'error' : null}
                              placeholder='Confirm Password'
                              className='h-[40px] border-[#C3D2E2]'
                              iconRender={(visible) =>
                                visible ? (
                                  <img
                                    src='/images/pwd_hid.svg'
                                    className='cursor-pointer'
                                  />
                                ) : (
                                  <img
                                    src='/images/pwd_vis.svg'
                                    className='cursor-pointer'
                                  />
                                )
                              }
                            />
                          );
                        }}
                      />
                      {errors.confirmpassword && (
                        <p className='text-[13px] text-[#ff4d4f]'>
                          {errors.confirmpassword.message}
                        </p>
                      )}
                    </div>
                  </>
                )}
              </div>
              <div className='flex gap-[0_20px] flex-wrap items-center'>
                <div className='mb-[20px] flex-[1_1_200px]'>
                  <label className='text-[#495159] text-[13px] font-[600] mb-[8px] block'>
                    Contact No.
                  </label>
                  <div className='flex items-center gap-[20px]'>
                    <Controller
                      control={control}
                      name='countryCode'
                      rules={{
                        required: true,
                      }}
                      render={({ field, fieldState }) => {
                        return (
                          <Select
                            {...field}
                            showSearch
                            status={fieldState.error ? 'error' : null}
                            suffixIcon={
                              <img
                                src='/images/select_ar.svg'
                                alt='arrow'
                                className='mr-[2px]'
                              />
                            }
                            className='h-[40px] border-[#C3D2E2] w-[80px]'
                            defaultValue={'+65'}
                          >
                            {countryCode.map((item, idx) => {
                              return (
                                <Select.Option key={idx} value={item.dial_code}>
                                  {item.dial_code}
                                </Select.Option>
                              );
                            })}
                          </Select>
                        );
                      }}
                    />
                    <Controller
                      control={control}
                      name='phoneNumber'
                      rules={{
                        required: true,
                      }}
                      render={({ field, fieldState }) => {
                        //console.log('PHONENUMBERVALUE', field.value);
                        return (
                          <Input
                            {...field}
                            className='h-[40px] border-[#C3D2E2]'
                            status={fieldState.error ? 'error' : null}
                            placeholder='Contact Number'
                            maxLength={8}
                            onChange={(e) => {
                              const re = /^[0-9\b]+$/;
                              if (
                                e.target.value === '' ||
                                re.test(e.target.value)
                              ) {
                                setValue('phoneNumber', e.target.value);
                              }
                            }}
                          />
                        );
                      }}
                    />{' '}
                  </div>
                  {errors.phoneNumber && (
                    <p className='text-[13px] text-[#ff4d4f]'>
                      {errors.phoneNumber.message}
                    </p>
                  )}
                </div>
                <div className='mb-[20px] flex-[1_1_200px]'>
                  <label className='text-[#495159] text-[13px] font-[600] mb-[8px] block'>
                    Role
                  </label>

                  <Controller
                    control={control}
                    name='role'
                    rules={{
                      required: true,
                    }}
                    render={({ field, fieldState }) => {
                      //console.log('ROLEFIELDVALUE', field.value, RoleList);
                      return (
                        <Select
                          {...field}
                          showSearch
                          status={fieldState.error ? 'error' : null}
                          suffixIcon={
                            <img
                              src='/images/select_ar.svg'
                              alt='arrow'
                              className='mr-[2px]'
                            />
                          }
                          className='h-[40px] border-[#C3D2E2] w-full'
                        >
                          {RoleList.map((item, idx) => {
                            return (
                              <Select.Option key={idx} value={item.id}>
                                {item.role_name}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      );
                    }}
                  />
                </div>
                <div className='text-end w-full mb-[30px] mt-[10px]'>
                  <Button
                    className='h-[40px] border border-[#879FB7] min-w-[88px] rounded-[4px] font-[600] text-[14px] text-[#879FB7] mr-[20px] hover:border-[#879FB7!important] hover:text-[#879FB7!important]'
                    onClick={() => {
                      setUserModal({ open: false, type: 'create' });
                      reset();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type='primary'
                    htmlType='submit'
                    className='h-[40px] bg-[#055FFB] min-w-[182px] rounded-[4px] text-[14px] font-[600]'
                  >
                    {userModal?.type === 'edit'
                      ? 'Update User Account'
                      : 'Create User Account'}
                  </Button>
                </div>
              </div>

              <div className='flex items-center gap-[10px] mt-5'></div>
            </form>
          </div>
        </FormProvider>
      </div>
    </div>
  );
};

const ActiveAccounts = ({
  userAccounts,
  GetRoleName,
  activeTab,
  RoleList,
  UpdateUserStatus,
  HandleUserDelete,
  GetUserInfo,
  pagePermission,
}) => {
  const items = [
    {
      label: (
        <div className='flex items-center gap-[10px] text-[#203B50] text-[13px]'>
          <img src={EditIcon} /> Edit Details
        </div>
      ),
      key: '0',
    },
    {
      label: (
        <div className='flex items-center gap-[10px] text-[#203B50] text-[13px]'>
          <img src={EditIcon} />{' '}
          {activeTab == 1 ? 'De-Activate Account' : 'Activate Account'}
        </div>
      ),
      key: '2',
    },
    {
      label: pagePermission?.delete_permission == 1 && (
        <div className='flex items-center gap-[10px] text-[#F80707] text-[13px]'>
          <img src={DeleteIcon} /> Delete
        </div>
      ),
      key: '1',
    },
    // {
    //   label: (
    //     <div className='flex items-center gap-[10px] text-[#203B50] text-[13px]'>
    //       <img src={LoginIcon} /> Login
    //     </div>
    //   ),
    //   key: '3',
    // },
  ];
  const handleMenuClick = (e, id) => {
    if (e.key == 0) {
      GetUserInfo(id);
    } else if (e.key == 2) {
      let temp = RoleList?.filter((it) => it?.id == id);
      UpdateUserStatus(temp, 0, id);
    } else {
      HandleUserDelete(id);
    }
  };
  return (
    <div className='px-[26px] pt-[20px]'>
      <div className='bg-white p-[10px] rounded-[10px]'>
        <div className='userAcctableBox'>
          <table>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Contact No.</th>
                <th>Role</th>
                {pagePermission?.update_permission == 1 && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {userAccounts?.length > 0 &&
                userAccounts?.map((item) => (
                  <tr>
                    <td>{item?.firstName}</td>
                    <td>{item?.lastName}</td>
                    <td>{item?.email}</td>
                    {/* <td>
                                            {item?.password !== undefined && (
                                                <PasswordToggler pwd={item?.password} />
                                            )}
                                        </td> */}
                    <td>
                      {item.countryCode} {item?.phoneNumber}
                    </td>
                    <td>{GetRoleName(item?.role)}</td>
                    <td>
                      {pagePermission?.update_permission == 1 && (
                        <Dropdown
                          overlayClassName='userAccDropdown'
                          menu={{
                            items,
                            onClick: (e) => {
                              handleMenuClick(e, item?.id);
                            },
                          }}
                          trigger={['click']}
                        >
                          <img
                            src={MoreIcon}
                            width='22'
                            className='cursor-pointer'
                          />
                        </Dropdown>
                      )}
                    </td>
                  </tr>
                ))}
              {userAccounts?.length == 0 && (
                <tr>
                  {' '}
                  <td colspan='5' className='text-center'>
                    No records found
                  </td>{' '}
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const DeActiveAccounts = ({
  userAccounts,
  GetRoleName,
  activeTab,
  RoleList,
  UpdateUserStatus,
  HandleUserDelete,
  GetUserInfo,
  pagePermission,
}) => {
  const items = [
    {
      label: (
        <div className='flex items-center gap-[10px] text-[#203B50] text-[13px]'>
          <img src={EditIcon} /> Edit Details
        </div>
      ),
      key: '0',
    },
    {
      label: (
        <div className='flex items-center gap-[10px] text-[#203B50] text-[13px]'>
          <img src={EditIcon} />{' '}
          {activeTab == 1 ? 'De-Activate Account' : 'Activate Account'}
        </div>
      ),
      key: '2',
    },
    {
      label: pagePermission?.delete_permission == 1 && (
        <div className='flex items-center gap-[10px] text-[#F80707] text-[13px]'>
          <img src={DeleteIcon} /> Delete
        </div>
      ),
      key: '1',
    },
    // {
    //   label: (
    //     <div className='flex items-center gap-[10px] text-[#203B50] text-[13px]'>
    //       <img src={LoginIcon} /> Login
    //     </div>
    //   ),
    //   key: '3',
    // },
  ];
  const handleMenuClick = (e, id) => {
    if (e.key == 0) {
      GetUserInfo(id);
    } else if (e.key == 2) {
      let temp = RoleList?.filter((it) => it?.id == id);
      UpdateUserStatus(temp, 1, id);
    } else {
      HandleUserDelete(id);
    }
  };
  return (
    <div className='px-[26px] pt-[20px]'>
      <div className='bg-white p-[10px] rounded-[10px]'>
        <div className='userAcctableBox'>
          <table>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Contact No.</th>
                <th>Role</th>
                {pagePermission?.update_permission == 1 && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {userAccounts?.length > 0 &&
                userAccounts?.map((item) => (
                  <tr>
                    <td>{item?.firstName}</td>
                    <td>{item?.lastName}</td>
                    <td>{item?.email}</td>
                    {/* <td>
                                            {item?.password !== undefined && (
                                                <PasswordToggler pwd={item?.password} />
                                            )}
                                        </td> */}
                    <td>
                      {item.countryCode} {item?.phoneNumber}
                    </td>
                    <td>{GetRoleName(item?.role)}</td>
                    <td>
                      {pagePermission?.update_permission == 1 && (
                        <Dropdown
                          overlayClassName='userAccDropdown'
                          menu={{
                            items,
                            onClick: (e) => {
                              handleMenuClick(e, item?.id);
                            },
                          }}
                          trigger={['click']}
                        >
                          <img
                            src={MoreIcon}
                            width='22'
                            className='cursor-pointer'
                          />
                        </Dropdown>
                      )}
                    </td>
                  </tr>
                ))}
              {userAccounts?.length == 0 && (
                <tr>
                  {' '}
                  <td colspan='5' className='text-center'>
                    No records found
                  </td>{' '}
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const PasswordToggler = (props) => {
  const { pwd } = props;
  const [pwdVis, setPwdVis] = useState(false);
  return (
    <div className='flex items-center gap-[17px]'>
      {pwdVis ? pwd : <span>{pwd.replace(/./g, '*')}</span>}
      <span className='cursor-pointer' onClick={() => setPwdVis(!pwdVis)}>
        {pwdVis ? (
          <img src='/images/pwd_hid.svg' />
        ) : (
          <img src='/images/pwd_vis.svg' />
        )}
      </span>
    </div>
  );
};

export default UserAccounts;

/**
 *
 *
 *
 * <div className="px-[30px]">
                                <h3 className="text-[18px] font-[600] pb-[10px] border-b border-[#E0E0E0]">Account Details</h3>
                                <form>
                                    <div className="flex gap-[0_20px] flex-wrap items-center mt-[30px]">
                                        <div className="mb-[20px] flex-[1_1_200px]">
                                            <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">First Name</label>
                                            <Input className="h-[40px] border-[#C3D2E2!important]" />
                                            <Controller
                                                control={control}
                                                name="name"
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => {
                                                    return (
                                                        <Input {...field} status={errors?.s_no ? 'error' : null} className="h-[40px] border-[#C3D2E2!important]" />
                                                    )
                                                }}
                                            />
                                        </div>
                                        <div className="mb-[20px] flex-[1_1_200px]">
                                            <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">Last Name</label>
                                            <Input className="h-[40px] border-[#C3D2E2!important]" />
                                        </div>
                                    </div>
                                    <div className="mb-[20px] flex-[1_1_200px]">
                                        <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">Email</label>
                                        <Input className="h-[40px] border-[#C3D2E2!important]" />
                                    </div>
                                    <div className="flex gap-[0_20px] flex-wrap items-center">
                                        <div className="mb-[20px] flex-[1_1_200px]">
                                            <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">Password</label>
                                            <Input.Password className="h-[40px] border-[#C3D2E2!important]" iconRender={(visible) => visible ? <img src="/images/pwd_hid.svg" className="cursor-pointer" /> : <img src="/images/pwd_vis.svg" className="cursor-pointer" />} />
                                        </div>
                                        <div className="mb-[20px] flex-[1_1_200px]">
                                            <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">Confirm Password</label>
                                            <Input.Password className="h-[40px] border-[#C3D2E2!important]" iconRender={(visible) => visible ? <img src="/images/pwd_hid.svg" className="cursor-pointer" /> : <img src="/images/pwd_vis.svg" className="cursor-pointer" />} />
                                        </div>
                                    </div>
                                    <div className="flex gap-[0_20px] flex-wrap items-center">
                                        <div className="mb-[20px] flex-[1_1_200px]">
                                            <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">Contact No.</label>
                                            <div className="flex items-center gap-[20px]">
                                                <Select
                                                    className="aacusSelect aacusSelectSml"
                                                    options={[
                                                        {
                                                            value: '+65',
                                                            label: '+65'
                                                        },
                                                        {
                                                            value: '+45',
                                                            label: '+45'
                                                        },
                                                        {
                                                            value: '+91',
                                                            label: '+91'
                                                        }
                                                    ]}
                                                    suffixIcon={<img src="/images/selecArr.svg" width="18" />}
                                                />
                                                <Input className="h-[40px] border-[#C3D2E2!important]" />
                                            </div>
                                        </div>
                                        <div className="mb-[20px] flex-[1_1_200px]">
                                            <label className="text-[#495159] text-[13px] font-[600] mb-[8px] block">Role</label>
                                            <Select
                                                className="aacusSelect"
                                                options={[
                                                    {
                                                        value: 'employee',
                                                        label: 'Employee'
                                                    },
                                                    {
                                                        value: 'employer',
                                                        label: 'Employer'
                                                    },
                                                    {
                                                        value: 'admin',
                                                        label: 'Admin'
                                                    }
                                                ]}
                                                suffixIcon={<img src="/images/selecArr.svg" width="18" />}
                                            />
                                        </div>
                                        <div className="text-end w-full mb-[30px] mt-[10px]">
                                            <Button className="h-[40px] border border-[#879FB7] min-w-[88px] rounded-[4px] font-[600] text-[14px] text-[#879FB7] mr-[20px] hover:border-[#879FB7!important] hover:text-[#879FB7!important]" onClick={() => setUserModal(false)}>Cancel</Button>
                                            <Button type="primary" htmlType="submit" className="h-[40px] bg-[#055FFB] min-w-[182px] rounded-[4px] text-[14px] font-[600]">Create User Account</Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
 */
